<template>
  <div @click="selectTransportChoice(transportChoiceId, transportTypeId)"></div>
</template>

<script>
export default {
  props: ['transportChoiceId', 'transportTypeId'],
  methods: {
    selectTransportChoice(transportChoiceId, transportTypeId) {
      this.$formValues['frm-form-transport_type_choices_' + transportTypeId + ':change'] =
        transportChoiceId

      this.$nextTick(() => {
        document.querySelector('#frm-form-transport_type_id-' + transportTypeId).click()
      })
    }
  }
}
</script>
